// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Cwiw","inner":"Footer_inner__3zNXA","nextIcon":"Footer_nextIcon__3JQON","innerLeft":"Footer_innerLeft__UdqDb"};